import { createAction } from '@reduxjs/toolkit';

import * as sellerActionTypes from './actionTypes';

export const getSellers = createAction<{ forceRefresh?: boolean }>(
  sellerActionTypes.GET_SELLER.BASE,
);
